import React, { useState, useEffect, useCallback } from "react";
import ReactJson from "react-json-view";
import sorter from "sort-nested-json";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

import VerifiedTrue from "../assests/Green.svg";
import VerifiedFalse from "../assests/Red.svg";
import "./DataTable.css";

export default function DataTable(props) {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  const [twoHeadercolumns, setTwoHeaderColumns] = useState([]);
  const [moreThRows, setMoreThRows] = useState([]);

  const [showSortArrow, setShowSortArrow] = useState([]);
  const [sortDirection, setSortDirection] = useState([]);

  const [showSubtableArrowDirection, setShowSubtableArrowDirection] = useState(
    []
  );
  const [showSubtableAfterRow, setShowSubtableAfterRow] = useState([]);

  const [paginantionPageNumber, setPaginantionPageNumber] = useState([]);
  const [paginantionAmountOfData, setPaginantionAmountOfData] = useState([]);

  const [
    paginantionSelectedPageNumber,
    setPaginantionSelectedPageNumber,
  ] = useState(1);
  const [paginantionToalPage, setPaginantionTotalPage] = useState(0);
  const [
    paginantionSelectedAmountOfData,
    setPaginantionSelectedAmountOfData,
  ] = useState(10);
  const [
    paginantionTotalAmountOfData,
    setPaginantionTotalAmountOfData,
  ] = useState(0);

  const [isPagination, setIsPagination] = useState(true);
  const [isShowCheckBox, setIsShowCheckBox] = useState(false);
  const [isSubTable, setIsSubTable] = useState(false);
  const [isTwoHeaderCol, setIsTwoHeaderCol] = useState(false);
  const [isRowsDraggable, setIsRowsDraggable] = useState(false);
  const [isMoreThRows, setIsMoreThRows] = useState(false);

  useEffect(() => {
    setColumns(props?.columns);
    setRows(props?.rows);
    // //console.log('props.rows: ', props?.rows);

    let page_number =
      paginantionSelectedPageNumber < 1 ? 1 : paginantionSelectedPageNumber;
    let temp_data = props?.rows.map((item, i) => ({
      ...item,
      noIndex: (page_number - 1) * paginantionSelectedAmountOfData + i + 1,
    }));

    setRows(temp_data);
    // //console.log('temp_data: ', page_number);

    if (
      (props?.isCollapsibleTableJSONData &&
        props?.isCollapsibleTableJSONData === true) ||
      (props?.isCollapsibleTableData && props?.isCollapsibleTableData === true)
    ) {
      temp_data = temp_data.map((item) => ({
        ...item,
        plusMinusIcon: false,
      }));

      setRows(temp_data);
      // //console.log('temp_data: ', temp_data);
    }

    if (
      props?.columns &&
      props?.columns?.length > 0 &&
      props.columns.find((val) => val?.format?.type === "action")?.format
        ?.formatfunction?.approvedItem
    ) {
      temp_data = temp_data.map((item) => ({
        ...item,
        isApproveItemDisabled: false,
      }));

      setRows(temp_data);
      // //console.log('temp_data: ', temp_data);
    }

    if (
      props?.columns &&
      props?.columns?.length > 0 &&
      props.columns.find((val) => val?.format?.type === "action")?.format
        ?.formatfunction?.rejectItem
    ) {
      temp_data = temp_data.map((item) => ({
        ...item,
        isRejectItemDisabled: false,
        rejectReason: "",
      }));

      setRows(temp_data);
      // //console.log('temp_data: ', temp_data);
    }

    if (props?.isSubTable && props?.isSubTable === true) {
      // temp_data = props?.rows;

      temp_data.forEach((element, i) => {
        temp_data[i].show_subtable = false;
        // temp_data.index = i;
      });
      setRows(temp_data);
      // //console.log('temp_data: ', temp_data);

      // let show_subtable_arrow_direction = [];
      // let show_subtable_after_row = [];
      // props.rows.forEach(() => {
      //   show_subtable_arrow_direction.push('right');
      //   show_subtable_after_row.push(false);
      // });
      // setShowSubtableArrowDirection(show_subtable_arrow_direction);
      // setShowSubtableAfterRow(show_subtable_after_row);
    }
  }, [props?.rows]);

  useEffect(() => {
    setColumns(props?.columns);
    //console.log('props.columns: ', props?.columns);

    let show_sort_arrow = {};
    let sort_direction = {};
    props.columns.forEach((element) => {
      show_sort_arrow[element.dataField] = false;
      sort_direction[element.dataField] = "asc";
    });
    setShowSortArrow(show_sort_arrow);
    setSortDirection(sort_direction);
  }, [props?.columns]);

  useEffect(() => {
    var temp_data = [];
    props.columns.forEach((element) => {
      temp_data.push({
        dataField: "",
        text: "",
        sort: false,
        show: true,
        format: {
          style: element?.format?.style,
          thStyle: {},
        },
      });
    });

    //console.log('twoHeadercolumns: ', temp_data);

    let position = 0;
    props?.twoHeadercolumns &&
      props.twoHeadercolumns.forEach((element) => {
        let pos = position + Math.ceil(element?.format?.colSpan / 2);
        temp_data[pos].dataField = element.dataField;
        temp_data[pos].text = element.text;

        position = position + element?.format?.colSpan;
        // //console.log(position)
        temp_data[position].format.thStyle = {
          borderRight: "2px solid #fff",
        };
      });

    // //console.log('twoHeadercolumns: ', temp_data);

    setTwoHeaderColumns(temp_data);
    // // //console.log('props.twoHeadercolumns: ', props?.twoHeadercolumns);
  }, [props?.twoHeadercolumns]);

  useEffect(() => {
    setMoreThRows(props?.moreThRows);
    // //console.log('props.moreThRows: ', props?.moreThRows);
  }, [props?.moreThRows]);

  useEffect(() => {
    setIsPagination(props?.isPagination);
    // //console.log('props.isPagination: ', props?.isPagination);
  }, [props?.isPagination]);

  useEffect(() => {
    setIsShowCheckBox(props?.isShowCheckBox);
    // //console.log('props.isShowCheckBox: ', props?.isShowCheckBox);
  }, [props?.isShowCheckBox]);

  useEffect(() => {
    setIsSubTable(props?.isSubTable);
    // //console.log('props.isSubTable: ', props?.isSubTable);
  }, [props?.isSubTable]);

  useEffect(() => {
    setIsTwoHeaderCol(props?.isTwoHeaderCol);
    // // //console.log('props.isTwoHeaderCol: ', props?.isTwoHeaderCol);
  }, [props?.isTwoHeaderCol]);

  useEffect(() => {
    setIsRowsDraggable(props?.isRowsDraggable);
    // // //console.log('props.isRowsDraggable: ', props?.isRowsDraggable);
  }, [props?.isRowsDraggable]);

  useEffect(() => {
    setIsMoreThRows(props?.isMoreThRows);
    // // //console.log('props.isMoreThRows: ', props?.isMoreThRows);
  }, [props?.isMoreThRows]);

  useEffect(() => {
    var temp_paginantionAmountOfData = [10, 20, 30, 50, 100, 500, 1000, 2000];
    var temp_array = [];

    let i = 0;
    for (i = 0; i < temp_paginantionAmountOfData.length; i++) {
      if (temp_paginantionAmountOfData[i] < props?.paginantionTotalAmountOfData)
        temp_array.push(temp_paginantionAmountOfData[i]);
      else break;
    }
    if (temp_array.length !== temp_paginantionAmountOfData.length)
      temp_array.push(temp_paginantionAmountOfData[i]);

    var total_page = Math.ceil(
      props?.paginantionTotalAmountOfData / paginantionSelectedAmountOfData
    );

    //console.log("total_page", total_page, paginantionSelectedAmountOfData)

    // setUpThePaginationNumber(paginantionSelectedPageNumber, total_page);
    // // //console.log('props.paginantionSelectedPageNumber: ', paginantionSelectedPageNumber);
    setUpThePaginationNumber(1, total_page);
    // // //console.log('props.paginantionSelectedPageNumber: ', 1);

    setPaginantionSelectedPageNumber(1);
    setPaginantionTotalPage(total_page);
    setPaginantionAmountOfData(temp_array);
    setPaginantionTotalAmountOfData(props?.paginantionTotalAmountOfData);
    setPaginantionSelectedAmountOfData(paginantionSelectedAmountOfData);
  }, [props?.paginantionTotalAmountOfData]);

  const setUpThePaginationNumber = (current_page, total_page) => {
    var current_page_number = 0;
    if (current_page < 1) current_page_number = 1;
    else if (current_page > total_page) current_page_number = total_page;
    else current_page_number = current_page;

    var pagination_number_array = [];
    var page_number = current_page_number;
    var display_page_number = total_page >= 5 ? 5 : total_page;

    if (current_page_number === 1) {
      // "1", 2, 3, 4, 5
      for (let i = 0; i < display_page_number; i++)
        pagination_number_array.push(page_number++);
    } else if (current_page_number === 2) {
      // 1, "2", 3, 4, 5
      pagination_number_array.push(page_number - 1);
      for (let i = 0; i < display_page_number - 1; i++)
        pagination_number_array.push(page_number++);
    } else if (current_page_number === total_page) {
      // x = total_page
      // x-4, x-3, x-2, x-1, "x"
      page_number = total_page - display_page_number;
      for (let i = 0; i < display_page_number; i++)
        pagination_number_array.push(++page_number);
    } else if (current_page_number === total_page - 1) {
      // x = total_page
      // x-4, x-3, x-2, "x-1", x
      page_number = total_page - display_page_number;
      for (let i = 0; i < display_page_number - 1; i++)
        pagination_number_array.push(++page_number);

      pagination_number_array.push(++page_number);
    } else {
      // x = current_page_number
      // x-2, x-1, "x", x+1, x+2
      page_number = current_page_number - 2;
      for (let i = 0; i < display_page_number; i++)
        pagination_number_array.push(page_number++);
    }

    //console.log("current_page_number 0", display_page_number)
    //console.log("current_page_number 1", current_page)
    //console.log("current_page_number 2", total_page)
    //console.log("current_page_number 3", current_page_number)

    // //console.log('pagination_number_array: ', current_page_number, pagination_number_array);
    setPaginantionSelectedPageNumber(current_page_number);
    setPaginantionPageNumber(pagination_number_array);
  };

  const onChangePaginantionSelectedAmountOfData = (e) => {
    setPaginantionSelectedAmountOfData(e.target.value);

    var total_page = Math.ceil(
      props?.paginantionTotalAmountOfData / e.target.value
    );

    setUpThePaginationNumber(1, total_page); // paginantionSelectedPageNumber

    setPaginantionTotalPage(total_page);

    var current_page = 1; // paginantionSelectedPageNumber
    var current_page_number = 0;
    if (current_page < 1) current_page_number = 1;
    else if (current_page > total_page) current_page_number = total_page;
    else current_page_number = current_page;

    // //console.log('current_page_number: ', current_page_number)

    props?.DataTablePaginationAPICall &&
      props.DataTablePaginationAPICall({
        skip: (current_page_number - 1) * paginantionSelectedAmountOfData,
        page: 1,
        limit: Number(e.target.value),
      });

    setPaginantionSelectedAmountOfData(e.target.value);
  };

  const onClickPaginantionSelectedPageNumber = (value) => {
    //console.log("value onClickPaginantionSelectedPageNumber", value)
    setPaginantionSelectedPageNumber(value);
    setUpThePaginationNumber(value, paginantionToalPage);
    props.DataTablePaginationAPICall &&
      props.DataTablePaginationAPICall({
        skip: (value - 1) * paginantionSelectedAmountOfData,
        limit: paginantionSelectedAmountOfData,
        page: value,
      });
    setPaginantionSelectedPageNumber(value);
  };

  // Table Column Sort Function
  const compareBy = (key, sort_direction) => {
    if (sort_direction === "asc") {
      return function(a, b) {
        if (a[key] < b[key]) return -1;
        if (a[key] > b[key]) return 1;
        return 0;
      };
    } else if (sort_direction === "desc") {
      return function(a, b) {
        if (a[key] < b[key]) return 1;
        if (a[key] > b[key]) return -1;
        return 0;
      };
    }
  };

  // onClick Table Column Th for Sort
  const onClickSortCol = (key) => {
    let show_sort_arrow = showSortArrow;

    Object.keys(show_sort_arrow).forEach((obj_key) => {
      if (obj_key === key) show_sort_arrow[obj_key] = true;
      else show_sort_arrow[obj_key] = false;
    });
    setShowSortArrow(show_sort_arrow);

    // let sort_key = dataFromNestedKeys(key)

    let arrayCopy = [...rows];
    // arrayCopy.sort(compareBy(key, sortDirection[key]));

    if (sortDirection[key] === "asc")
      arrayCopy = sorter.sort(arrayCopy).asc(key);
    else arrayCopy = sorter.sort(arrayCopy).desc(key);

    setRows(arrayCopy);
    // this.setState({rows: arrayCopy});

    let sort_direction = sortDirection;
    if (sort_direction[key] === "asc") sort_direction[key] = "desc";
    else if (sort_direction[key] === "desc") sort_direction[key] = "asc";
    setSortDirection(sort_direction);
  };

  const onClickSubTalbeArrow = useCallback((row_id) => {
    let temp_data = rows;

    for (let i = 0; i < temp_data.length; i++) {
      if (temp_data[i]._id === row_id)
        temp_data[i].show_subtable = !temp_data[i].show_subtable;
    }

    setRows(temp_data);

    // setRows(old_array => {
    //   return old_array.map((item) => {
    //     return item._id === row_id ? !item.show_subtable : !item.show_subtable
    //   })
    // })

    // setIsSubTable(false);

    // if(temp_data[index] === 'right')
    //   show_subtable_arrow_direction[index] = 'down';
    // else if(show_subtable_arrow_direction[index] === 'down')
    //   show_subtable_arrow_direction[index] = 'right';

    // // show_subtable_arrow_direction[index] = !show_subtable_arrow_direction[index];
    // setShowSubtableArrowDirection(show_subtable_arrow_direction);
    // //console.log(show_subtable_arrow_direction)
  });

  const onClickPlusMinusIcon = (row_value) => {
    let temp_data = [...rows];

    for (let i = 0; i < temp_data.length; i++) {
      if (temp_data[i].noIndex === row_value.noIndex) {
        temp_data[i].plusMinusIcon = !temp_data[i].plusMinusIcon;
        break;
      }
    }

    setRows(temp_data);
  };

  const dataFromNestedKeys = (jsonKeyString, row_value) => {
    let cell_data = "";

    if (String(jsonKeyString).includes(".")) {
      let key_data = String(jsonKeyString).split(".");

      cell_data = row_value;
      // //console.log(
      //   cell_data
      // );
      for (let i = 0; i < key_data?.length; i++) {
        //  //console.log(key_data);
        if (cell_data && key_data[i] in cell_data)
          cell_data = cell_data[key_data[i]];
        else cell_data = null;
      }
    } else {
      cell_data = row_value[jsonKeyString];
    }

    return cell_data === undefined ? null : cell_data;
  };

  const createTableCellForAction = (row_value, col_value, cell_data, key) => {
    return (
      <td
        className="datatable-cell min-w-150px"
        data-field={col_value?.dataField}
        data-autohide-disabled="false"
        aria-label="null"
        key={key}
        style={col_value?.format?.tdStyle}
      >
        <span style={{ width: col_value?.format?.style?.width }}>
          {/* <span style={{ overflow: 'visible', position: 'relative', width: col_value?.format?.style?.width, }}> */}
          {col_value?.format?.formatfunction?.settingsItem && (
            <div className="dropdown dropdown-inline">
              <a
                className="btn btn-sm btn-light btn-text-primary btn-icon mr-2"
                data-toggle="dropdown"
                aria-expanded="false"
              >
                <span className="svg-icon svg-icon-md">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    xlink="http://www.w3.org/1999/xlink"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    version="1.1"
                  >
                    <g
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <rect x="0" y="0" width="24" height="24"></rect>
                      <path
                        d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                        fill="#000000"
                      ></path>
                    </g>
                  </svg>
                </span>
              </a>
              <div
                className="dropdown-menu dropdown-menu-sm dropdown-menu-right"
                style={{}}
              >
                <ul className="navi flex-column navi-hover py-2">
                  <li className="navi-header font-weight-bolder text-uppercase font-size-xs text-primary pb-2">
                    Choose an action:
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="la la-print"></i>
                      </span>
                      <span className="navi-text">Print</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="la la-copy"></i>
                      </span>
                      <span className="navi-text">Copy</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="la la-file-excel-o"></i>
                      </span>
                      <span className="navi-text">Excel</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="la la-file-text-o"></i>
                      </span>
                      <span className="navi-text">CSV</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a href="#" className="navi-link">
                      <span className="navi-icon">
                        <i className="la la-file-pdf-o"></i>
                      </span>
                      <span className="navi-text">PDF</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          )}
          {col_value?.format?.formatfunction?.viewItem && (
            <a
              className="btn btn-icon btn-light btn-text-primary btn-sm mr-2"
              title="View"
              onClick={() => {
                col_value.format.formatfunction.viewItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  {/* <title>
                  Stockholm-icons / General / Visible
                </title> */}
                  <desc>Created with Sketch.</desc>
                  <defs></defs>
                  <g
                    id="Stockholm-icons-/-General-/-Visible"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M3,12 C3,12 5.45454545,6 12,6 C16.9090909,6 21,12 21,12 C21,12 16.9090909,18 12,18 C5.45454545,18 3,12 3,12 Z"
                      id="Shape"
                      fill="#000000"
                      fillRule="nonzero"
                    ></path>
                    <path
                      d="M12,15 C10.3431458,15 9,13.6568542 9,12 C9,10.3431458 10.3431458,9 12,9 C13.6568542,9 15,10.3431458 15,12 C15,13.6568542 13.6568542,15 12,15 Z"
                      id="Path"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.settingItem1 && (
            <a
              className="btn1 btn-sm btn-light btn-hover-warning btn-icon mr-2"
              title="Edit setting"
              onClick={() => {
                col_value.format.formatfunction.settingItem1(row_value);
              }}
              style={
                row_value.isCalled
                  ? {
                      color: "#ffffff",
                      backgroundColor: "#1BC5BD",
                      borderColor: "#1BC5BD",
                    }
                  : {}
              }
            >
              {row_value.isCalled ? "Called" : "Call"}
            </a>
          )}
          {col_value?.format?.formatfunction?.editItem && (
            <a
              className="btn btn-sm btn-light btn-hover-success btn-icon mr-2"
              title="Edit details"
              onClick={() => {
                col_value.format.formatfunction.editItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-success">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                    ></path>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="5"
                      y="20"
                      width="15"
                      height="2"
                      rx="1"
                    ></rect>
                  </g>
                </svg>
              </span>
            </a>
          )}
           {col_value?.format?.formatfunction?.exportItem && ((row_value?.contestFor || []).find(obj => obj.companyCode === "IG" ) !== undefined) && (
            <a
              className="btn btn-sm btn-light btn-hover-success btn-icon mr-2"
              title="Edit details"
              onClick={() => {
                col_value.format.formatfunction.exportItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-success">
              <svg  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                   x="0" y="0" viewBox="0 0 24 24" >
             <g xmlns="http://www.w3.org/2000/svg">
    <path d="M13 16.75h5V18a2.652 2.652 0 0 1-3 3H6a2.652 2.652 0 0 1-3-3V6a2.652 2.652 0 0 1 3-3h5.25v3A3.381 3.381 0 0 0 15 9.75h3v5.5h-5a.75.75 0 0 0 0 1.5zm2-8.5h2.25l-4.5-4.5V6c0 1.58.67 2.25 2.25 2.25zm7.692 7.463a.771.771 0 0 0-.162-.244l-2-2a.75.75 0 0 0-1.06 1.06l.719.72H18v1.5h2.189l-.719.72a.75.75 0 1 0 1.06 1.06l2-2a.751.751 0 0 0 .162-.817z" fill="#1171d4" opacity="1" data-original="#000000"/>
  </g>
            </svg>
              </span>
            </a>
          )}
          {console.log("row_value", )}
          {col_value?.format?.formatfunction?.addMiniumSlot && (((row_value?.contestFor || []).find(obj => obj.companyCode === "IG") ) != undefined) && (
            <a
              className="btn btn-sm btn-light btn-hover-success btn-icon mr-2"
              title="Add Minimum Slot"
              onClick={() => {
                col_value.format.formatfunction.addMiniumSlot(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-warning">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  svg="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Stockholm-icons-/-General-/-Settings-2"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                      id="Combined-Shape"
                      fill="#000000"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.viewItem1 && (
            <a
              onClick={() => {
                col_value.format.formatfunction.viewItem1(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md">
                {/* <title>
        Stockholm-icons / General / Visible
      </title> */}
                <desc>{row_value.contest}</desc>
                <defs></defs>
                <g
                  id="Stockholm-icons-/-General-/-Visible"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                ></g>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.viewItemProfile && (
            <a
              onClick={() => {
                col_value.format.formatfunction.viewItemProfile(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md">
                {/* <title>
        Stockholm-icons / General / Visible
      </title> */}
                <desc>{row_value.user_id}</desc>
                <defs></defs>
                <g
                  id="Stockholm-icons-/-General-/-Visible"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                ></g>
              </span>
            </a>
          )}

          {col_value?.format?.formatfunction?.viewItemProfileee && (
            <a
              onClick={() => {
                col_value.format.formatfunction.viewItemProfileee(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md">
                {/* <title>
        Stockholm-icons / General / Visible
      </title> */}
                <desc>{row_value?.userID || row_value?._id}</desc>
                <defs></defs>
                <g
                  id="Stockholm-icons-/-General-/-Visible"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                ></g>
              </span>
            </a>
          )}

          {col_value?.format?.formatfunction?.viewItemProfilehostid && (
            <a
              onClick={() => {
                col_value.format.formatfunction.viewItemProfilehostid(
                  row_value
                );
              }}
            >
              <span className="svg-icon svg-icon-md">
                {/* <title>
        Stockholm-icons / General / Visible
      </title> */}
                <desc>{row_value.hostedBy}</desc>
                <defs></defs>
                <g
                  id="Stockholm-icons-/-General-/-Visible"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                ></g>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.viewTournamentItem && (
            <a
              onClick={() => {
                col_value.format.formatfunction.viewTournamentItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md">
                {/* <title>
        Stockholm-icons / General / Visible
      </title> */}
                <desc>{row_value.event}</desc>
                <defs></defs>
                <g
                  id="Stockholm-icons-/-General-/-Visible"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                ></g>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.viewItem2 && (
            <a
              onClick={() => {
                col_value.format.formatfunction.viewItem2(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md">
                {/* <title>
        Stockholm-icons / General / Visible
      </title> */}
                <desc>User id</desc>
                <defs></defs>
                <g
                  id="Stockholm-icons-/-General-/-Visible"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                ></g>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.settingItem && (
            <a
              className="btn btn-sm btn-light btn-hover-warning btn-icon mr-2"
              title="Edit setting"
              onClick={() => {
                col_value.format.formatfunction.settingItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-warning">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  svg="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Stockholm-icons-/-General-/-Settings-2"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                      id="Combined-Shape"
                      fill="#000000"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.settingScrim && (
            <a
              className="btn btn-sm btn-light btn-hover-gray-400 btn-icon mr-2"
              title="Scrim setting"
              onClick={() => {
                col_value.format.formatfunction.settingScrim(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md .bg-gray-800">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  svg="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Stockholm-icons-/-General-/-Settings-2"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z"
                      id="Combined-Shape"
                      fill="black"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.downloadItem && (
            <a
              className="btn btn-sm btn-light btn-hover-sucess btn-icon mr-2"
              title="Download setting"
              onClick={() => {
                col_value.format.formatfunction.settingItem(row_value);
              }}
            >
              <span class="svg-icon svg-icon-primary svg-icon-2x">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <path
                      d="M2,13 C2,12.5 2.5,12 3,12 C3.5,12 4,12.5 4,13 C4,13.3333333 4,15 4,18 C4,19.1045695 4.8954305,20 6,20 L18,20 C19.1045695,20 20,19.1045695 20,18 L20,13 C20,12.4477153 20.4477153,12 21,12 C21.5522847,12 22,12.4477153 22,13 L22,18 C22,20.209139 20.209139,22 18,22 L6,22 C3.790861,22 2,20.209139 2,18 C2,15 2,13.3333333 2,13 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      opacity="0.3"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      transform="translate(12.000000, 8.000000) rotate(-180.000000) translate(-12.000000, -8.000000) "
                      x="11"
                      y="1"
                      width="2"
                      height="14"
                      rx="1"
                    />
                    <path
                      d="M7.70710678,15.7071068 C7.31658249,16.0976311 6.68341751,16.0976311 6.29289322,15.7071068 C5.90236893,15.3165825 5.90236893,14.6834175 6.29289322,14.2928932 L11.2928932,9.29289322 C11.6689749,8.91681153 12.2736364,8.90091039 12.6689647,9.25670585 L17.6689647,13.7567059 C18.0794748,14.1261649 18.1127532,14.7584547 17.7432941,15.1689647 C17.3738351,15.5794748 16.7415453,15.6127532 16.3310353,15.2432941 L12.0362375,11.3779761 L7.70710678,15.7071068 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      transform="translate(12.000004, 12.499999) rotate(-180.000000) translate(-12.000004, -12.499999) "
                    />
                  </g>
                </svg>
              </span>
            </a>
          )}
          {col_value?.format?.formatfunction?.typeRedirect && (
            <a
              className="btn btn-sm btn-light btn-hover-info btn-icon mr-2"
              title="Game Types"
              onClick={() => {
                col_value.format.formatfunction.typeRedirect(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-info">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  svg="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    id="Stockholm-icons-/-General-/-Settings-1"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M7,3 L17,3 C19.209139,3 21,4.790861 21,7 C21,9.209139 19.209139,11 17,11 L7,11 C4.790861,11 3,9.209139 3,7 C3,4.790861 4.790861,3 7,3 Z M7,9 C8.1045695,9 9,8.1045695 9,7 C9,5.8954305 8.1045695,5 7,5 C5.8954305,5 5,5.8954305 5,7 C5,8.1045695 5.8954305,9 7,9 Z"
                      id="Combined-Shape"
                      fill="#000000"
                    ></path>
                    <path
                      d="M7,13 L17,13 C19.209139,13 21,14.790861 21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 C3,14.790861 4.790861,13 7,13 Z M17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 C15.8954305,15 15,15.8954305 15,17 C15,18.1045695 15.8954305,19 17,19 Z"
                      id="Combined-Shape"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          )}
          {
            col_value?.format?.formatfunction?.companyCountryRedirect &&
            <a className="btn btn-sm btn-light btn-hover-info btn-icon mr-2" title="Countries"
              onClick={() => { col_value.format.formatfunction.companyCountryRedirect(row_value) }}
            >
              <span className="svg-icon svg-icon-md svg-icon-info">
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" svg="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
                  <g id="Stockholm-icons-/-General-/-Settings-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path d="M7,3 L17,3 C19.209139,3 21,4.790861 21,7 C21,9.209139 19.209139,11 17,11 L7,11 C4.790861,11 3,9.209139 3,7 C3,4.790861 4.790861,3 7,3 Z M7,9 C8.1045695,9 9,8.1045695 9,7 C9,5.8954305 8.1045695,5 7,5 C5.8954305,5 5,5.8954305 5,7 C5,8.1045695 5.8954305,9 7,9 Z" id="Combined-Shape" fill="#000000"></path>
                    <path d="M7,13 L17,13 C19.209139,13 21,14.790861 21,17 C21,19.209139 19.209139,21 17,21 L7,21 C4.790861,21 3,19.209139 3,17 C3,14.790861 4.790861,13 7,13 Z M17,19 C18.1045695,19 19,18.1045695 19,17 C19,15.8954305 18.1045695,15 17,15 C15.8954305,15 15,15.8954305 15,17 C15,18.1045695 15.8954305,19 17,19 Z" id="Combined-Shape" fill="#000000" opacity="0.3"></path>
                  </g>
                </svg>
              </span>
            </a>
          }
          {col_value?.format?.formatfunction?.allocateTeamItem ? (
            <a
              className="btn btn-sm btn-light btn-hover-success btn-icon mr-2"
              title="Approved"
              onClick={() => {
                col_value.format.formatfunction.allocateTeamItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-success">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <defs></defs>
                  <g
                    id="Stockholm-icons-/-General-/-Like"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
                      id="Path-42"
                      fill="#000000"
                    ></path>
                    <rect
                      id="Rectangle-153"
                      fill="#000000"
                      opacity="0.3"
                      x="2"
                      y="9"
                      width="5"
                      height="11"
                      rx="1"
                    ></rect>
                  </g>
                </svg>
              </span>
            </a>
          ) : (
            <></>
          )}
          {col_value?.format?.formatfunction?.requestGameType &&
          row_value?.isInstallableGame === true ? (
            <a
              className="btn btn-sm btn-light btn-hover-success btn-icon mr-2"
              title="Approved"
              onClick={() => {
                col_value.format.formatfunction.requestGameType(row_value);
              }}
            >
              <span class="svg-icon svg-icon-primary svg-icon-2x">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <path
                      d="M18,15 L18,13.4774152 C18,13.3560358 18.0441534,13.2388009 18.1242243,13.147578 C18.3063883,12.9400428 18.622302,12.9194754 18.8298372,13.1016395 L21.7647988,15.6778026 C21.7814819,15.6924462 21.7971714,15.7081846 21.811763,15.7249133 C21.9932797,15.933015 21.9717282,16.2488631 21.7636265,16.4303797 L18.828665,18.9903994 C18.7375973,19.0698331 18.6208431,19.1135979 18.5,19.1135979 C18.2238576,19.1135979 18,18.8897403 18,18.6135979 L18,17 L16.445419,17 C14.5938764,17 12.8460429,16.1451629 11.7093057,14.6836437 L7.71198984,9.54423755 C6.95416504,8.56989138 5.7889427,8 4.55458097,8 L2,8 L2,6 L4.55458097,6 C6.40612357,6 8.15395708,6.85483706 9.29069428,8.31635632 L13.2880102,13.4557625 C14.045835,14.4301086 15.2110573,15 16.445419,15 L18,15 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                      opacity="0.3"
                    />
                    <path
                      d="M18,6 L18,4.4774157 C18,4.3560363 18.0441534,4.23880134 18.1242243,4.14757848 C18.3063883,3.94004327 18.622302,3.9194759 18.8298372,4.10163997 L21.7647988,6.67780304 C21.7814819,6.69244668 21.7971714,6.70818509 21.811763,6.72491379 C21.9932797,6.93301548 21.9717282,7.24886356 21.7636265,7.43038021 L18.828665,9.99039986 C18.7375973,10.0698336 18.6208431,10.1135984 18.5,10.1135984 C18.2238576,10.1135984 18,9.88974079 18,9.61359842 L18,8 L16.445419,8 C15.2110573,8 14.045835,8.56989138 13.2880102,9.54423755 L9.29069428,14.6836437 C8.15395708,16.1451629 6.40612357,17 4.55458097,17 L2,17 L2,15 L4.55458097,15 C5.7889427,15 6.95416504,14.4301086 7.71198984,13.4557625 L11.7093057,8.31635632 C12.8460429,6.85483706 14.5938764,6 16.445419,6 L18,6 Z"
                      fill="#000000"
                      fill-rule="nonzero"
                    />
                  </g>
                </svg>
              </span>
            </a>
          ) : (
            <></>
          )}
          {col_value?.format?.formatfunction?.approvedTeamItem &&
          row_value?.status === "PENDING" ? (
            <a
              className="btn btn-sm btn-light btn-hover-success btn-icon mr-2"
              title="Approved"
              onClick={() => {
                col_value.format.formatfunction.approvedTeamItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-success">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <defs></defs>
                  <g
                    id="Stockholm-icons-/-General-/-Like"
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
                      id="Path-42"
                      fill="#000000"
                    ></path>
                    <rect
                      id="Rectangle-153"
                      fill="#000000"
                      opacity="0.3"
                      x="2"
                      y="9"
                      width="5"
                      height="11"
                      rx="1"
                    ></rect>
                  </g>
                </svg>
              </span>
            </a>
          ) : (
            <></>
          )}
          {col_value?.format?.formatfunction?.rejectTeamItem &&
          row_value?.status === "PENDING" ? (
            <a
              className="btn btn-sm btn-light btn-hover-danger btn-icon mr-2"
              title="Reject"
              onClick={() => {
                col_value.format.formatfunction.rejectTeamItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  style={{ transform: `rotateX(180deg)` }}
                >
                  <defs></defs>
                  <g
                    id="Stockholm-icons-/-General-/-Like"
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <rect id="bound" x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
                      id="Path-42"
                      fill="#000000"
                    ></path>
                    <rect
                      id="Rectangle-153"
                      fill="#000000"
                      opacity="0.3"
                      x="2"
                      y="9"
                      width="5"
                      height="11"
                      rx="1"
                    ></rect>
                  </g>
                </svg>
              </span>
            </a>
          ) : (
            <></>
          )}
          {col_value?.format?.formatfunction?.deleteItem && (
            <a
              className="btn btn-sm btn-light btn-hover-danger btn-icon mr-2"
              title="Delete"
              onClick={() => {
                col_value.format.formatfunction.deleteItem(row_value);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-danger">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24"></rect>
                    <path
                      d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z"
                      fill="#000000"
                      fillRule="nonzero"
                    ></path>
                    <path
                      d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z"
                      fill="#000000"
                      opacity="0.3"
                    ></path>
                  </g>
                </svg>
              </span>
            </a>
          )}

          {/* {
            col_value?.format?.formatfunction?.approvedItem &&
            col_value.format.formatfunction.approvedItem(row_value)
          }
          {
            col_value?.format?.formatfunction?.rejectItem &&
            col_value.format.formatfunction.rejectItem(row_value)
          } */}
          {col_value?.format?.formatfunction?.approvedItem && (
            <div className="dropdown dropdown-inline">
              {row_value?.requestStatus === "pending" ? (
                <button
                  className="btn btn-icon btn-light btn-hover-success btn-sm mr-2"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  disabled={
                    row_value?.isApproveItemDisabled ||
                    row_value?.isRejectItemDisabled
                  }
                >
                  <span className="svg-icon svg-icon-md svg-icon-success">
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                    >
                      {/* <title>Stockholm-icons / General / Like</title> */}
                      {/* <desc>Created with Sketch.</desc> */}
                      <defs></defs>
                      <g
                        id="Stockholm-icons-/-General-/-Like"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect
                          id="bound"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        ></rect>
                        <path
                          d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
                          id="Path-42"
                          fill="#000000"
                        ></path>
                        <rect
                          id="Rectangle-153"
                          fill="#000000"
                          opacity="0.3"
                          x="2"
                          y="9"
                          width="5"
                          height="11"
                          rx="1"
                        ></rect>
                      </g>
                    </svg>
                  </span>
                </button>
              ) : (
                ""
              )}
              <div
                className={`dropdown-menu dropdown-menu-right ${row_value?.isApproveItemDisabled &&
                  "d-none"}`}
                x-placement="bottom-right"
                style={{}}
              >
                <div className="px-2 text-center">
                  <div className="font-weight-bolder">Are you sure?</div>
                  <div className="mt-2">
                    <div className="btn-group">
                      <button
                        className="btn btn-xs btn-success"
                        style={{ whiteSpace: "nowrap" }}
                        onClick={() => {
                          let temp_data = [...rows];

                          for (let i = 0; i < temp_data.length; i++) {
                            if (temp_data[i].noIndex === row_value.noIndex) {
                              temp_data[i].isApproveItemDisabled = true;
                              break;
                            }
                          }

                          setRows(temp_data);
                          col_value.format.formatfunction.approvedItem(
                            row_value
                          );
                        }}
                      >
                        <i className="flaticon2-check-mark icon-md"></i> Yes
                      </button>
                      <button
                        className="btn btn-xs btn-danger"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        <i className="flaticon2-cross icon-sm"></i> No
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {col_value?.format?.formatfunction?.rejectItem && (
            <div className="dropdown dropdown-inline">
              {row_value?.requestStatus === "pending" ? (
                <button
                  className="btn btn-icon btn-light btn-hover-danger btn-sm mr-2"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  disabled={
                    row_value?.isRejectItemDisabled ||
                    row_value?.isApproveItemDisabled
                  }
                >
                  <span className="svg-icon svg-icon-md svg-icon-danger">
                    <svg
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      xlink="http://www.w3.org/1999/xlink"
                      style={{ transform: "rotateX(180deg)" }}
                    >
                      {/* <title>Stockholm-icons / General / Like</title> */}
                      {/* <desc>Created with Sketch.</desc> */}
                      <defs></defs>
                      <g
                        id="Stockholm-icons-/-General-/-Like"
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect
                          id="bound"
                          x="0"
                          y="0"
                          width="24"
                          height="24"
                        ></rect>
                        <path
                          d="M9,10 L9,19 L10.1525987,19.3841996 C11.3761964,19.7920655 12.6575468,20 13.9473319,20 L17.5405883,20 C18.9706314,20 20.2018758,18.990621 20.4823303,17.5883484 L21.231529,13.8423552 C21.5564648,12.217676 20.5028146,10.6372006 18.8781353,10.3122648 C18.6189212,10.260422 18.353992,10.2430672 18.0902299,10.2606513 L14.5,10.5 L14.8641964,6.49383981 C14.9326895,5.74041495 14.3774427,5.07411874 13.6240179,5.00562558 C13.5827848,5.00187712 13.5414031,5 13.5,5 L13.5,5 C12.5694044,5 11.7070439,5.48826024 11.2282564,6.28623939 L9,10 Z"
                          id="Path-42"
                          fill="#000000"
                        ></path>
                        <rect
                          id="Rectangle-153"
                          fill="#000000"
                          opacity="0.3"
                          x="2"
                          y="9"
                          width="5"
                          height="11"
                          rx="1"
                        ></rect>
                      </g>
                    </svg>
                  </span>
                </button>
              ) : (
                ""
              )}
              <div
                className={`dropdown-menu dropdown-menu-right dropdown-menu-xl 
                ${row_value?.isRejectItemDisabled && "d-none"}`}
                x-placement="bottom-right"
                style={{}}
              >
                <div className="px-2 text-center">
                  <div className="">
                    <textarea
                      rows={3}
                      className="form-control"
                      placeholder="Reason"
                      value={row_value?.rejectReason}
                      onChange={(e) => {
                        let temp_data = [...rows];

                        for (let i = 0; i < temp_data.length; i++) {
                          if (temp_data[i].noIndex === row_value.noIndex) {
                            temp_data[i].rejectReason = e.target.value;
                            break;
                          }
                        }

                        setRows(temp_data);
                      }}
                    />
                  </div>
                  <div className="mt-2">
                    <div className="d-flex w-100 justify-content-center">
                      <button
                        className="btn btn-sm btn-danger mr-2"
                        onClick={() => {
                          if (!row_value?.rejectReason) {
                            NotificationManager.error(
                              "Please add Reason!",
                              "Error"
                            );
                            return;
                          } else {
                            let temp_data = [...rows];

                            for (let i = 0; i < temp_data.length; i++) {
                              if (temp_data[i].noIndex === row_value.noIndex) {
                                temp_data[i].isRejectItemDisabled = true;
                                break;
                              }
                            }

                            setRows(temp_data);
                            col_value.format.formatfunction.rejectItem(
                              row_value
                            );
                          }
                        }}
                      >
                        Reject
                      </button>
                      <button
                        className="btn btn-sm btn-primary ml-2"
                        onClick={() => {
                          let temp_data = [...rows];

                          for (let i = 0; i < temp_data.length; i++) {
                            if (temp_data[i].noIndex === row_value.noIndex) {
                              temp_data[i].rejectReason = "";
                              break;
                            }
                          }

                          setRows(temp_data);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </span>
      </td>
    );
  };

  const createTableCellForTexbox = (row_value, col_value, cell_data, key) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={
          col_value?.format?.tdStyleFormatter
            ? col_value?.format?.tdStyleFormatter(cell_data)
            : col_value?.format?.tdStyle
        }
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {props.rank !== undefined ? (
            <input
              type="text"
              className="form-control"
              // placeholder="Search"
              value={key}
              // onChange={(e) => { setSearchText(e.target.value) }}
            />
          ) : (
            "-"
          )}
        </span>
      </td>
    );
  };

  const createTableCellForType = (row_value, col_value, cell_data, key) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {cell_data !== undefined && cell_data !== null && (
            <>
              <span
                className={`label label-${col_value?.format?.color} label-dot mr-2`}
              ></span>
              <span
                className={`font-weight-bold text-${col_value?.format?.color}`}
              >
                {cell_data}
              </span>
            </>
          )}
        </span>
      </td>
    );
  };

  const createTableCellForIsActive = (row_value, col_value, cell_data, key) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
      >
        {/* <div className="form-group row"> */}
        {/* <label className="col-3 col-form-label">Success</label> */}
        {/* <div className="col-3"> */}
        <span
          className="switch switch-outline switch-icon switch-dark data_table_cell_value"
          style={col_value?.format?.style}
        >
          <label>
            <input
              type="checkbox"
              checked={cell_data}
              name="select"
              onChange={(e) => {
                let temp = row_value;
                temp.isActive = e.target.checked;
                if (col_value?.format?.formatfunction?.onChangeIsActive)
                  col_value.format.formatfunction.onChangeIsActive(temp);
              }}
            />
            <span></span>
          </label>
        </span>
        {/* </div> */}
        {/* </div> */}
      </td>
    );
  };

  const createTableCellForStatus = (row_value, col_value, cell_data, key) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {cell_data !== undefined && cell_data !== null && (
            <span
              className={`label font-weight-bold label-lg label-light-${col_value?.format?.color} label-inline label-bold`}
              style={col_value?.format?.childSpanStyle}
            >
              {cell_data}
            </span>
          )}
        </span>
      </td>
    );
  };

  const createTableCellForImage = (row_value, col_value, cell_data, key) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
      >
        {cell_data ? (
          <span
            className="data_table_cell_value"
            style={col_value?.format?.style}
          >
            <img
              className="data_table_cell_image"
              style={{ width: '70%', height: '80px' }}
              src={
                col_value?.format?.formatter
                  ? col_value.format.formatter(cell_data, row_value)
                  : cell_data
              }
            />{" "}
            {/* ${url} */}
          </span>
        ) : (
          <>-</>
        )}
      </td>
    );
  };

  const createTableCellForImageTwoDataRow = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    let bgImage = dataFromNestedKeys(col_value?.bgImage, row_value);
    let secondRow = dataFromNestedKeys(col_value?.secondRow, row_value);

    if (bgImage !== null && col_value?.format?.bgImageFormatter)
      bgImage = col_value?.format.bgImageFormatter(bgImage);

    if (secondRow !== null && col_value?.format?.secondRowFormatter)
      secondRow = col_value?.format.bgImageFormatter(secondRow);

    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={
          col_value?.format?.tdStyleFormatter
            ? col_value?.format?.tdStyleFormatter(cell_data)
            : col_value?.format?.tdStyle
        }
      >
        <span style={col_value?.format?.style}>
          <div className="d-flex align-items-center">
            <div className="symbol symbol-40 flex-shrink-0">
              <div
                className="symbol-label"
                style={{ backgroundImage: `url('${bgImage}')` }}
              ></div>
            </div>
            <div className="ml-2">
              <div className="text-dark-75 font-weight-bold line-height-sm">
                {cell_data}
              </div>
              <a className="font-size-sm text-dark-50 text-hover-primary">
                {secondRow}
              </a>
            </div>
          </div>
        </span>
      </td>
    );
  };

  const createTableCellForTickCancel = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {cell_data === true && ( // <i className="fa fa-check" style={{ color: '#183c32' }}></i>
            // <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
            //   <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM371.8 211.8C382.7 200.9 382.7 183.1 371.8 172.2C360.9 161.3 343.1 161.3 332.2 172.2L224 280.4L179.8 236.2C168.9 225.3 151.1 225.3 140.2 236.2C129.3 247.1 129.3 264.9 140.2 275.8L204.2 339.8C215.1 350.7 232.9 350.7 243.8 339.8L371.8 211.8z"/>
            // </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 448 512"
            >
              <path
                d="M438.6 105.4C451.1 117.9 451.1 138.1 438.6 150.6L182.6 406.6C170.1 419.1 149.9 419.1 137.4 406.6L9.372 278.6C-3.124 266.1-3.124 245.9 9.372 233.4C21.87 220.9 42.13 220.9 54.63 233.4L159.1 338.7L393.4 105.4C405.9 92.88 426.1 92.88 438.6 105.4H438.6z"
                fill="#66ff00"
              />
            </svg>
          )}
          {cell_data === false && ( // <i className="fa fa-xmark" style={{ color: '#183c32' }}></i>
            // <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
            //   <path d="M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM175 208.1L222.1 255.1L175 303C165.7 312.4 165.7 327.6 175 336.1C184.4 346.3 199.6 346.3 208.1 336.1L255.1 289.9L303 336.1C312.4 346.3 327.6 346.3 336.1 336.1C346.3 327.6 346.3 312.4 336.1 303L289.9 255.1L336.1 208.1C346.3 199.6 346.3 184.4 336.1 175C327.6 165.7 312.4 165.7 303 175L255.1 222.1L208.1 175C199.6 165.7 184.4 165.7 175 175C165.7 184.4 165.7 199.6 175 208.1V208.1z"/>
            // </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 320 512"
            >
              <path
                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                fill="#ff3d3d"
              />
            </svg>
          )}
        </span>
      </td>
    );
  };

  const createTableCellForPlusMinusIcon = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
        onClick={() => onClickPlusMinusIcon(row_value)}
      >
        <span
          className="data_table_cell_value cursor-pointer"
          style={col_value?.format?.style}
        >
          {cell_data ? (
            <i
              className="fa fa-solid fa-minus fa-sm text-dark"
              aria-hidden="true"
            ></i>
          ) : (
            <i
              className="fa fa-solid fa-plus fa-sm text-dark"
              aria-hidden="true"
            ></i>
          )}
        </span>
      </td>
    );
  };

  const createTableCellForCollasibleDataIcon = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={col_value?.format?.tdStyle}
        onClick={() => {
          onClickPlusMinusIcon(row_value);
          if (col_value?.format?.formatfunction?.onClickIcon) {
            col_value.format.formatfunction.onClickIcon(row_value);
          }
        }}
      >
        <span
          className="data_table_cell_value cursor-pointer"
          style={col_value?.format?.style}
        >
          {cell_data ? (
            <i
              className="fa fa-solid fa-minus fa-sm text-dark"
              aria-hidden="true"
            ></i>
          ) : (
            <i
              className="fa fa-solid fa-plus fa-sm text-dark"
              aria-hidden="true"
            ></i>
          )}
        </span>
      </td>
    );
  };

  const createTableCellForRowCollasibleJSONData = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    if (row_value.plusMinusIcon) {
      // //console.log(JSON.parse(cell_data))
      return (
        <tr>
          <td
            className="datatable-cell data_table_cell"
            data-field={col_value?.dataField}
            aria-label={cell_data}
            key={key}
            style={col_value?.format?.tdStyle}
            colSpan={columns.length}
          >
            <span
              className="data_table_cell_value"
              style={col_value?.format?.style}
            >
              {cell_data && <ReactJson src={cell_data} theme="hopscotch" />}
            </span>
          </td>
        </tr>
      );
    }
  };

  const createCollapsibleTableJSONData = (row_value, key) => {
    if (row_value.plusMinusIcon) {
      // //console.log(JSON.parse(cell_data))
      let cell_data = dataFromNestedKeys(
        columns[columns.length - 1].dataField,
        row_value
      );
      return (
        <tr>
          <td
            className="datatable-cell data_table_cell"
            // data-field={col_value?.dataField}
            // aria-label={cell_data}
            key={key}
            // style={col_value?.format?.tdStyle}
            colSpan={columns.length}
          >
            <span
              className="data_table_cell_value"
              // style={col_value?.format?.style}
            >
              {cell_data && <ReactJson src={cell_data} theme="hopscotch" />}
            </span>
          </td>
        </tr>
      );
    }
  };

  const createCollapsibleTableData = (row_value, key) => {
    if (row_value.plusMinusIcon) {
      // //console.log(JSON.parse(cell_data))
      let col_value = columns.find(
        (val) => val?.format?.type === "collasibleDataIcon"
      );
      return (
        <tr>
          <td
            className="datatable-cell data_table_cell"
            // data-field={col_value?.dataField}
            // aria-label={cell_data}
            key={key}
            // style={col_value?.format?.tdStyle}
            colSpan={columns.length}
          >
            <span
              className="data_table_cell_value"
              // style={col_value?.format?.style}
            >
              {col_value?.format?.formatfunction?.returnCollasibleData &&
                col_value.format.formatfunction.returnCollasibleData(
                  row_value,
                  props?.collasibleRowData
                )}
            </span>
          </td>
        </tr>
      );
    }
  };

  const createTableCellForVerify = (row_value, col_value, cell_data, key) => {
    let tag_verify_data = dataFromNestedKeys(
      col_value?.format?.verifyField,
      row_value
    );

    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={
          col_value?.format?.tdStyleFormatter
            ? col_value?.format?.tdStyleFormatter(cell_data)
            : col_value?.format?.tdStyle
        }
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {cell_data !== undefined && cell_data !== null ? (
            col_value?.format?.formatter ? (
              col_value.format.formatter(cell_data, row_value)
            ) : (
              <div style={{ whiteSpace: "nowrap" }}>
                {tag_verify_data ? (
                  <img src={VerifiedTrue} className="max-w-20px mr-2" />
                ) : (
                  <img src={VerifiedFalse} className="max-w-20px mr-2" />
                )}
                {String(cell_data)}
              </div>
            )
          ) : col_value?.format?.undefinedNullFormatter ? (
            col_value?.format?.undefinedNullFormatter(
              col_value?.format?.undefinedNullFormat
            )
          ) : (
            "-"
          )}
        </span>
      </td>
    );
  };

  const createTableCellForConditionalDropdown = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    let tag_dropdownCondition =
      col_value?.format?.dropdownCondition &&
      col_value?.format?.dropdownCondition(row_value);
    let dropdownData = [];

    col_value?.format?.dropdownField &&
      col_value.format.dropdownField.forEach((element) => {
        if (dataFromNestedKeys(element, row_value))
          dropdownData.push(dataFromNestedKeys(element, row_value));
      });

    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={
          col_value?.format?.tdStyleFormatter
            ? col_value?.format?.tdStyleFormatter(cell_data)
            : col_value?.format?.tdStyle
        }
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {cell_data !== undefined && cell_data !== null ? (
            <div style={{ whiteSpace: "nowrap" }}>
              {col_value?.format?.formatter
                ? col_value.format.formatter(cell_data, row_value)
                : String(cell_data)}
              {tag_dropdownCondition && (
                <div className="dropdown dropdown-inline">
                  <a
                    className="btn btn-xs btn-light btn-text-primary btn-icon ml-2"
                    data-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="flaticon2-down icon-sm"></i>
                  </a>
                  <div className="dropdown-menu dropdown-menu-xl" style={{}}>
                    <ul className="navi flex-column navi-hover py-2">
                      {dropdownData.map((value, i) => {
                        return (
                          <li className="navi-item" key={i}>
                            <a className="navi-link">
                              <span
                                className="navi-text"
                                style={{ whiteSpace: "normal" }}
                              >
                                {value}
                              </span>
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              )}
            </div>
          ) : col_value?.format?.undefinedNullFormatter ? (
            col_value?.format?.undefinedNullFormatter(
              col_value?.format?.undefinedNullFormat
            )
          ) : (
            "-"
          )}
        </span>
      </td>
    );
  };

  const createTableCellForNormalData = (
    row_value,
    col_value,
    cell_data,
    key
  ) => {
    return (
      <td
        className="datatable-cell data_table_cell"
        data-field={col_value?.dataField}
        aria-label={cell_data}
        key={key}
        style={
          col_value?.format?.tdStyleFormatter
            ? col_value?.format?.tdStyleFormatter(cell_data)
            : col_value?.format?.tdStyle
        }
      >
        <span
          className="data_table_cell_value"
          style={col_value?.format?.style}
        >
          {cell_data !== undefined && cell_data !== null
            ? col_value?.format?.formatter
              ? col_value.format.formatter(cell_data, row_value)
              : String(cell_data)
            : col_value?.format?.undefinedNullFormatter
            ? col_value?.format?.undefinedNullFormatter(
                col_value?.format?.undefinedNullFormat
              )
            : "-"}
        </span>
      </td>
    );
  };

  const createTableCell = (row_value) => {
    return columns.map((value, i) => {
      let cell_data = dataFromNestedKeys(value?.dataField, row_value);

      switch (String(value?.format?.type)) {
        case "action":
          return createTableCellForAction(row_value, value, cell_data, i);
        case "type":
          return createTableCellForType(row_value, value, cell_data, i);
        case "isActive":
          return createTableCellForIsActive(row_value, value, cell_data, i);
        case "status":
          return createTableCellForStatus(row_value, value, cell_data, i);
        case "image":
          return createTableCellForImage(row_value, value, cell_data, i);
        case "imageTwoDataRow":
          return createTableCellForImageTwoDataRow(
            row_value,
            value,
            cell_data,
            i
          );
        case "tickCancel":
          return createTableCellForTickCancel(row_value, value, cell_data, i);
        case "plusMinusIcon":
          return createTableCellForPlusMinusIcon(
            row_value,
            value,
            cell_data,
            i
          );
        // case 'rowCollasibleJSONData': return createTableCellForRowCollasibleJSONData(row_value, value, cell_data, i);
        case "rowCollasibleJSONData":
          break;
        case "collasibleDataIcon":
          return createTableCellForCollasibleDataIcon(
            row_value,
            value,
            cell_data,
            i
          );
        case "verify":
          return createTableCellForVerify(row_value, value, cell_data, i);
        case "conditionalDropdown":
          return createTableCellForConditionalDropdown(
            row_value,
            value,
            cell_data,
            i
          );

        case "textbox":
          return createTableCellForTexbox(row_value, value, cell_data, i);

        default:
          return createTableCellForNormalData(row_value, value, cell_data, i);
      }
    });
  };

  const createTableRow = () => {
    return rows.map((value, i) => {
      let subtable_arrow_direction = "";
      // //console.log(showSubtableRow[i])

      if (value?.show_subtable === true) subtable_arrow_direction = "down";
      else if (value?.show_subtable === false)
        subtable_arrow_direction = "right";

      var backgroundColor = "#000";
      if (value?.isRejected) {
        backgroundColor = `#F64E60`;
      } else if (value?.isAccepted) {
        backgroundColor = `#228C22`;
      }

      return (
        <Draggable
          draggableId={String(i)}
          key={i}
          index={i}
          isDragDisabled={!isRowsDraggable}
        >
          {(provided) => (
            <>
              <tr
                data-row={value?._id}
                className="datatable-row data_table_tr"
                tyle={{ left: "0px" }}
                key={i}
                ref={provided.innerRef}
                {...provided.draggableProps}
                style={{ left: "0px", color: backgroundColor }}
              >
                {isRowsDraggable === true && (
                  <td
                    className="datatable-cell data_table_cell"
                    data-field="row-draggable"
                    key={97 + i}
                    style={value?.format?.tdStyle}
                    {...provided.dragHandleProps}
                  >
                    <span
                      className="data_table_cell_value_row_draggable"
                      onClick={() => onClickSubTalbeArrow(value?._id)}
                    >
                      <i className="fas fa-grip-horizontal"></i>
                    </span>
                  </td>
                )}

                {isSubTable === true && (
                  <td
                    className="datatable-cell data_table_cell"
                    data-field="subtable-arrow"
                    // aria-label={cell_data}
                    key={98 + i}
                    style={value?.format?.tdStyle}
                  >
                    <span
                      className="data_table_cell_value_subtable_arrow"
                      onClick={() => onClickSubTalbeArrow(value?._id)}
                    >
                      <i
                        className={`fa fa-caret-${subtable_arrow_direction}`}
                      ></i>
                    </span>
                  </td>
                )}

                {isShowCheckBox === true && (
                  <td
                    className="datatable-cell data_table_cell"
                    data-field="checkbox"
                    // aria-label={cell_data}
                    key={99 + i}
                    style={value?.format?.tdStyle}
                  >
                    <span className="data_table_cell_value_checkbox">
                      <label className="checkbox checkbox-single kt-checkbox--solid">
                        <input
                          type="checkbox"
                          value={value?._id}
                          data-event={value?.event || null}
                          checked={props?.selectedList?.includes(value?._id)}
                          onClick={props.onClickCheckbox}
                        />
                        &nbsp;
                        <span></span>
                      </label>
                    </span>
                  </td>
                )}

                {createTableCell(value)}
              </tr>
              {props?.isCollapsibleTableJSONData &&
                createCollapsibleTableJSONData(value, i)}
              {props?.isCollapsibleTableData &&
                createCollapsibleTableData(value, i)}
            </>
          )}
        </Draggable>
      );
    });
  };

  const createTableCol = () => {
    return columns.map((value, i) => {
      if (value?.format?.type !== "rowCollasibleJSONData") {
        let style_icon = { color: "#fff" };
        let arrow_direction = "down";
        let className_cell_value = "";

        if (value?.sort && showSortArrow[value?.dataField])
          style_icon.display = "inline";
        else style_icon.display = "none";

        if (sortDirection[value?.dataField] === "asc") arrow_direction = "down";
        else if (sortDirection[value?.dataField] === "desc")
          arrow_direction = "up";

        if (value?.dataField === "image")
          className_cell_value = "data_table_cell_value_image";
        else className_cell_value = "data_table_cell_value";

        return (
          <th
            data-field={value?.dataField}
            data-sort="desc"
            key={i}
            className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
            onClick={() => {
              value?.sort === true && onClickSortCol(value?.dataField);
            }}
            colSpan={1}
            rowSpan={1}
            style={value?.format?.thStyle}
          >
            <span
              className={`${className_cell_value} data_table_th_value`}
              style={value?.format?.style}
            >
              {value?.text}
              <i
                className={`flaticon2-arrow-${arrow_direction} icon-nm ml-1`}
                style={style_icon}
              ></i>
            </span>
          </th>
        );
      }
    });
  };

  const createTableTwoHeaderCol = () => {
    return twoHeadercolumns.map((value, i) => {
      return (
        <th
          key={i}
          className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
          style={value?.format?.thStyle}
        >
          <span
            className={`data_table_cell_value data_table_th_value`}
            style={value?.format?.style}
          >
            {value?.text}
          </span>
        </th>
      );
    });
  };

  const createMoreThRows = () => {
    return moreThRows.map((value, i) => {
      return (
        <tr className="datatable-row" style={{ left: "0px" }} key={i}>
          {value.map((valueTh, i) => {
            return (
              // switch (String(valueTh?.format?.type)) {
              //   case 'status': return createTableCellForStatus(value, valueTh, valueTh?.text, i);
              //   default: return createTableCellForNormalData(value, valueTh, valueTh?.text, i);
              // }
              <th
                key={i}
                className="datatable-cell datatable-cell-sort data_table_cell data_table_more_th"
                style={
                  valueTh?.format?.thStyleFormatter
                    ? valueTh?.format?.thStyleFormatter(valueTh?.text)
                    : valueTh?.format?.thStyle
                }
              >
                <span
                  className={`data_table_cell_value data_table_more_th_value`}
                  style={valueTh?.format?.style}
                >
                  {valueTh?.text}
                </span>
              </th>
            );
          })}
        </tr>
      );
    });
  };

  // New component DataTableDropdown and Shifted to DateRangeFilterComponent
  const createDropDown = () => {
    return (
      <div className="row align-items-center mb-7">
        <div className="col-md-3 my-2 my-md-0">
          <div className="d-flex align-items-center">
            <label className="mr-3 mb-0 d-none d-md-block">Status:</label>
            <div className="dropdown dropdown-inline show data_table_main_dropdown">
              <button
                type="button"
                tabIndex="-1"
                data-toggle="dropdown"
                role="combobox"
                className="btn dropdown-toggle btn-light bs-placeholder data_table_dropdown_button"
                aria-owns="bs-select-1"
                aria-haspopup="listbox"
                aria-expanded="false"
                data-id="kt_datatable_search_status"
                title="All"
              >
                <div className="filter-option">
                  <div className="filter-option-inner">
                    <div className="filter-option-inner-inner">All</div>
                  </div>
                </div>
              </button>

              {/* <div className="dropdown-menu show data_table_main_dropdown_menu"
                x-placement="bottom-start">
                <div className="inner show data_table_main_dropdown_inner" role="listbox" id="bs-select-1" tabIndex="-1" aria-activedescendant="bs-select-1-0">
                  <ul className="dropdown-menu inner show data_table_main_dropdown_inner_ul" role="presentation">
                    <li className="selected active">
                      <a role="option" className="dropdown-item active selected" id="bs-select-1-0" tabIndex="0" aria-setsize="7" aria-posinset="1" aria-selected="true">
                        <span className="text">
                          All
                        </span>
                      </a>
                    </li>
                    <li className="">
                      <a role="option" className="dropdown-item" id="bs-select-1-1" tabIndex="0" aria-setsize="7" aria-posinset="2">
                        <span className="text">
                          Pending
                        </span>
                      </a>
                    </li>
                    <li>
                      <a role="option" className="dropdown-item" id="bs-select-1-2" tabIndex="0" aria-setsize="7" aria-posinset="3">
                        <span className="text">
                          Delivered
                        </span>
                      </a>
                    </li>
                    <li>
                      <a role="option" className="dropdown-item" id="bs-select-1-3" tabIndex="0" aria-setsize="7" aria-posinset="4">
                        <span className="text">
                          Canceled
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
              <div
                className="dropdown-menu dropdown-menu-sm dropdown-menu-right data_table_main_dropdown_menu"
                style={{
                  width: "100%",
                  position: "absolute",
                  willChange: "transform",
                  top: "0px",
                  left: "0px",
                  transform: "translate3d(0px, 40px, 0px)",
                }}
                x-placement="bottom-end"
              >
                <ul className="navi flex-column navi-hover py-2">
                  <li className="navi-item">
                    <a
                      href="#"
                      className="navi-link active data_table_dropdown_item_active"
                    >
                      <span className="navi-text">All</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a
                      href="#"
                      className="navi-link data_table_dropdown_item_active"
                    >
                      <span className="text">Success</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a
                      href="#"
                      className="navi-link data_table_dropdown_item_active"
                    >
                      <span className="-text">Pending</span>
                    </a>
                  </li>
                  <li className="navi-item">
                    <a
                      href="#"
                      className="navi-link data_table_dropdown_item_active"
                    >
                      <span className="-text">Failed</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const createTablePagination = () => {
    // Calculate the number of pages
    const numPages = Math.ceil(
      paginantionTotalAmountOfData / paginantionAmountOfData
    );

    return (
      <div className="d-flex justify-content-between align-items-center flex-wrap mt-4 p-4">
        <div className="d-flex flex-wrap py-2 mr-3">
          <a
            className={`btn btn-icon btn-sm btn-light mr-2 my-1 
            ${paginantionSelectedPageNumber === 1 ? "disabled" : ""}`}
            onClick={() => onClickPaginantionSelectedPageNumber(1)}
          >
            <i className="ki ki-bold-double-arrow-back icon-xs"></i>
          </a>
          <a
            className={`btn btn-icon btn-sm btn-light mr-2 my-1
            ${paginantionSelectedPageNumber === 1 ? "disabled" : ""}`}
            onClick={() =>
              onClickPaginantionSelectedPageNumber(
                paginantionSelectedPageNumber - 1
              )
            }
          >
            <i className="ki ki-bold-arrow-back icon-xs"></i>
          </a>

          {/* Conditionally render the ellipsis button */}
          {paginantionSelectedPageNumber > 1 && (
            <a className="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">
              ...
            </a>
          )}

{paginantionPageNumber.map((value, i) => {
  let selected_button_className = "";
  if (value === paginantionSelectedPageNumber)
    selected_button_className = "btn-hover-primary active";

  return (
    <a
      className={`btn btn-icon btn-sm border-0 btn-light mr-2 my-1 
        ${selected_button_className}`}
      key={i}
      onClick={() => onClickPaginantionSelectedPageNumber(value)}
      style={{
        height: 'calc(1.35em + 1.1rem + 2px)',
        width: 'calc(1.35em + 2.1rem + 2px)'
      }}
    >
      {value}
    </a>
  );
})}


          {/* Conditionally render the ellipsis button */}
          {paginantionSelectedPageNumber < paginantionToalPage && (
            <a className="btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1">
              ...
            </a>
          )}

          <a
            className={`btn btn-icon btn-sm btn-light mr-2 my-1
            ${
              paginantionSelectedPageNumber === paginantionToalPage
                ? "disabled"
                : ""
            }`}
            onClick={() =>
              onClickPaginantionSelectedPageNumber(
                paginantionSelectedPageNumber + 1
              )
            }
          >
            <i className="ki ki-bold-arrow-next icon-xs"></i>
          </a>
          <a
            className={`btn btn-icon btn-sm btn-light mr-2 my-1
            ${
              paginantionSelectedPageNumber === paginantionToalPage
                ? "disabled"
                : ""
            }`}
            onClick={() =>
              onClickPaginantionSelectedPageNumber(paginantionToalPage)
            }
          >
            <i className="ki ki-bold-double-arrow-next icon-xs"></i>
          </a>
        </div>
        <div className="d-flex align-items-center py-3">
{/* <div className="d-flex align-items-center">
            <div className="mr-2 text-muted">Loading...</div>
            <div className="spinner mr-10"></div>
          </div> */}
          <select
            className="form-control form-control-sm font-weight-bold mr-4 border-0 bg-light"
            style={{ width: "75px" }}
            onChange={(e) => onChangePaginantionSelectedAmountOfData(e)}
            value={paginantionSelectedAmountOfData}
          >
            {paginantionAmountOfData.map((value, i) => {
              return (
                <option value={value} key={i}>
                  {value}
                </option>
              );
            })}
<>
              {/* <option value="20">20</option>
              <option value="30">30</option>
              <option value="50">50</option>
              <option value="100">100</option>
              <option value="500">500</option>
              <option value="1000">1000</option>
              <option value="2000">2000</option> */}
            </>
          </select>
          <span className="text-muted">
            {`Displaying 
            ${props?.tournamentColsLength || props?.rows.length} 
            of
            ${paginantionTotalAmountOfData} 
            records`}
          </span>
        </div>
      </div>
    );
  };

  // Testing
  const test123 = {
    kind: "youtube#searchListResponse",
    etag: "7or-s-JIoT_vf7DeDGdr1uub48M",
    nextPageToken: "CAUQAA",
    regionCode: "IN",
    pageInfo: {
      totalResults: 1000000,
      resultsPerPage: 5,
    },
    items: [
      {
        kind: "youtube#searchResult",
        etag: "HvmnIzFTrnjg-8aNHH5UU1MwQJE",
        id: {
          kind: "youtube#video",
          videoId: "hq3yfQnllfQ",
        },
        snippet: {
          publishedAt: "2014-03-06T20:57:50Z",
          channelId: "UCBnZ16ahKA2DZ_T5W0FPUXg",
          title:
            "Phonics Song with TWO Words - A For Apple - ABC Alphabet Songs with Sounds for Children",
          description:
            "To download and watch this video anywhere and at any time, get the ChuChu TV Pro app now by clicking the below link!",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/hq3yfQnllfQ/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/hq3yfQnllfQ/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/hq3yfQnllfQ/hqdefault.jpg",
              width: 480,
              height: 360,
            },
          },
          channelTitle: "ChuChu TV Nursery Rhymes & Kids Songs",
          liveBroadcastContent: "none",
          publishTime: "2014-03-06T20:57:50Z",
        },
      },
      {
        kind: "youtube#searchResult",
        etag: "IZebh0MIEQKN9P6vKia47_uZKCo",
        id: {
          kind: "youtube#video",
          videoId: "71h8MZshGSs",
        },
        snippet: {
          publishedAt: "2019-04-12T07:00:00Z",
          channelId: "UCbCmjCuTUZos6Inko4u57UQ",
          title: "ABC Song + More Nursery Rhymes &amp; Kids Songs - CoComelon",
          description:
            "Subscribe for new videos every week! https://www.youtube.com/c/Cocomelon?sub_confirmation=1 A new compilation video, ...",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/71h8MZshGSs/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/71h8MZshGSs/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/71h8MZshGSs/hqdefault.jpg",
              width: 480,
              height: 360,
            },
          },
          channelTitle: "Cocomelon - Nursery Rhymes",
          liveBroadcastContent: "none",
          publishTime: "2019-04-12T07:00:00Z",
        },
      },
      {
        kind: "youtube#searchResult",
        etag: "YhTj2vCCJVgxB81XvggC8Bw08jA",
        id: {
          kind: "youtube#video",
          videoId: "Euajm_vNLW8",
        },
        snippet: {
          publishedAt: "2015-06-13T11:45:37Z",
          channelId: "UCUv5WKaX1XbDPr6rkoO67XA",
          title:
            "Learn Alphabet Train Song - 3D Animation Alphabet ABC Train song for children",
          description:
            "An alphabet train that teaches alphabets to children in a fun and colorful way. A B C D E F G H I J K L M N O P Q R S T U ...",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/Euajm_vNLW8/default.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/Euajm_vNLW8/mqdefault.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/Euajm_vNLW8/hqdefault.jpg",
              width: 480,
              height: 360,
            },
          },
          channelTitle: "Chu Chu Kids Train TV",
          liveBroadcastContent: "none",
          publishTime: "2015-06-13T11:45:37Z",
        },
      },
      {
        kind: "youtube#searchResult",
        etag: "zceMO89dGhu7hQ4Y2WyJ5phjrFg",
        id: {
          kind: "youtube#video",
          videoId: "9Pe_exAikiE",
        },
        snippet: {
          publishedAt: "2022-05-30T10:44:57Z",
          channelId: "UC7Pq3Ko42YpkCB_Q4E981jw",
          title:
            "ABC Song, Wheels On The Bus, Baby Shark + Many More Nursery Rhymes &amp; Kids Songs",
          description:
            "Kids TV is home to various popular nursery rhymes & kids songs featuring Bob the Train, Super Supremes, Junior Squad & more ...",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/9Pe_exAikiE/default_live.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/9Pe_exAikiE/mqdefault_live.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/9Pe_exAikiE/hqdefault_live.jpg",
              width: 480,
              height: 360,
            },
          },
          channelTitle: "Kids TV - Nursery Rhymes And Baby Songs",
          liveBroadcastContent: "live",
          publishTime: "2022-05-30T10:44:57Z",
        },
      },
      {
        kind: "youtube#searchResult",
        etag: "nXgnHIguv48SscZcXJmocVlukg4",
        id: {
          kind: "youtube#video",
          videoId: "9VerJbNuVQE",
        },
        snippet: {
          publishedAt: "2022-05-21T11:22:18Z",
          channelId: "UCk0IUODXaAFr5gEFlZDbzmw",
          title: "A.B.C-Z「Graceful Runner」ミュージックビデオ",
          description:
            "A.B.C-Z 12th Single「Graceful Runner」 2022.06.29 Release https://abcz.ponycanyon.co.jp/ 作詞・作曲：草野華余子 ...",
          thumbnails: {
            default: {
              url: "https://i.ytimg.com/vi/9VerJbNuVQE/default_live.jpg",
              width: 120,
              height: 90,
            },
            medium: {
              url: "https://i.ytimg.com/vi/9VerJbNuVQE/mqdefault_live.jpg",
              width: 320,
              height: 180,
            },
            high: {
              url: "https://i.ytimg.com/vi/9VerJbNuVQE/hqdefault_live.jpg",
              width: 480,
              height: 360,
            },
          },
          channelTitle: "ponycanyon",
          liveBroadcastContent: "upcoming",
          publishTime: "2022-05-21T11:22:18Z",
        },
      },
    ],
  };

  // Testing Continue
  const testPRE = () => {
    return (
      <pre
        className=""
        style={{
          backgroundColor: "#181C32",
          color: "#fff",
          margin: "10px",
          padding: "20px",
          borderRadius: "10px",
          maxHeight: "300px",
          overflow: "auto",
        }}
      >
        {JSON.stringify(test123, null, 4)}
      </pre>
    );
  };

  const handleDragEnd = (results) => {
    // //console.log(results);
    if (!results?.destination) return;
    let temp_rows = [...rows];
    let [selected_row] = temp_rows.splice(results?.source?.index, 1);
    temp_rows.splice(results?.destination?.index, 0, selected_row);
    setRows(temp_rows);
  };

  return (
    <div className="card-body p-0">
      <>
        {/* <div className="mb-7">
        <div className="row align-items-center">
          <div className="col-lg-9 col-xl-8">
            <div className="row align-items-center">
              <div className="col-md-4 my-2 my-md-0">
                <div className="input-icon">
                  <input type="text" className="form-control" placeholder="Search..." id="kt_datatable_search_query" />
                  <span>
                    <i className="flaticon2-search-1 text-muted">
                    </i>
                  </span>
                </div>
              </div>
              <div className="col-md-4 my-2 my-md-0">
                <div className="d-flex align-items-center">
                  <label className="mr-3 mb-0 d-none d-md-block">
                    Status:</label>
                  <div className="dropdown bootstrap-select form-control">
                    <select className="form-control" id="kt_datatable_search_status">

                      <option value="">
                        All</option>

                      <option value="1">
                        Pending</option>

                      <option value="2">
                        Delivered</option>

                      <option value="3">
                        Canceled</option>

                      <option value="4">
                        Success</option>

                      <option value="5">
                        Info</option>

                      <option value="6">
                        Danger</option>

                    </select>
                    <button type="button" tabIndex="-1" className="btn dropdown-toggle btn-light bs-placeholder" data-toggle="dropdown" role="combobox" aria-owns="bs-select-1" aria-haspopup="listbox" aria-expanded="false" data-id="kt_datatable_search_status" title="All">
                      <div className="filter-option">
                        <div className="filter-option-inner">
                          <div className="filter-option-inner-inner">
                            All</div>
                        </div>
                      </div>
                    </button>
                    <div className="dropdown-menu ">
                      <div className="inner show" role="listbox" id="bs-select-1" tabIndex="-1">
                        <ul className="dropdown-menu inner show" role="presentation">
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

              <div className="col-md-4 my-2 my-md-0">

                <div className="d-flex align-items-center">

                  <label className="mr-3 mb-0 d-none d-md-block">
                    Type:</label>

                  <div className="dropdown bootstrap-select form-control">
                    <select className="form-control" id="kt_datatable_search_type">

                      <option value="">
                        All</option>

                      <option value="1">
                        Online</option>

                      <option value="2">
                        Retail</option>

                      <option value="3">
                        Direct</option>

                    </select>
                    <button type="button" tabIndex="-1" className="btn dropdown-toggle btn-light bs-placeholder" data-toggle="dropdown" role="combobox" aria-owns="bs-select-2" aria-haspopup="listbox" aria-expanded="false" data-id="kt_datatable_search_type" title="All">
                      <div className="filter-option">
                        <div className="filter-option-inner">
                          <div className="filter-option-inner-inner">
                            All</div>
                        </div>
                      </div>
                    </button>
                    <div className="dropdown-menu ">
                      <div className="inner show" role="listbox" id="bs-select-2" tabIndex="-1">
                        <ul className="dropdown-menu inner show" role="presentation">
                        </ul>
                      </div>
                    </div>
                  </div>

                </div>

              </div>

            </div>

          </div>

          <div className="col-lg-3 col-xl-4 mt-5 mt-lg-0">

            <a href="#" className="btn btn-light-primary px-6 font-weight-bold">
              Search</a>

          </div>

        </div>

      </div> */}
      </>
      {props.rows.length > 0 ? (
        <div
          className="data_table_table_component datatable-bordered datatable-head-custom datatable-default datatable-primary datatable-loaded"
          id="kt_datatable"
          style={{ display: "block" }}
        >
          <DragDropContext onDragEnd={(results) => handleDragEnd(results)}>
            <table
              className="table dataTable datatable-table data_table_table"
              // style={{ display: 'block', }}
            >
              <thead className="datatable-head data_table_head">
                {isTwoHeaderCol === true && (
                  <tr className="datatable-row" style={{ left: "0px" }}>
                    {createTableTwoHeaderCol()}
                  </tr>
                )}
                <tr className="datatable-row" style={{ left: "0px" }}>
                  {isRowsDraggable === true && (
                    <th
                      data-field="row-draggable"
                      className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
                    >
                      <span className="data_table_cell_value_row_draggable">
                        {/* <i className="fas fa-grip-horizontal"></i> */}
                      </span>
                    </th>
                  )}

                  {isSubTable === true && (
                    <th
                      data-field="subtable-arrow"
                      className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
                    >
                      <span className="data_table_cell_value_subtable_arrow"></span>
                    </th>
                  )}

                  {isShowCheckBox === true && (
                    <th
                      data-field="checkbox"
                      className="datatable-cell datatable-cell-sort data_table_cell data_table_th"
                    >
                      <span className="data_table_cell_value_checkbox">
                        <label className="checkbox checkbox-single kt-checkbox--solid">
                          <input
                            type="checkbox"
                            value="1"
                            checked={props.selectedList.length === rows.length}
                            onClick={props?.onClickAll}
                          />
                          &nbsp;
                          <span></span>
                        </label>
                      </span>
                    </th>
                  )}

                  {createTableCol()}
                  <>
                    {/* <th data-field="RecordID" className="datatable-cell-center datatable-cell datatable-cell-sort datatable-cell-sorted" data-sort="desc">
                      <span style={{ width: '30px', }}>
                        #<i className="flaticon2-arrow-down">
                        </i>
                      </span>
                    </th>
                    <th data-field="OrderID" className="datatable-cell datatable-cell-sort" data-sort="desc">
                      <span style={{ width: '137px', }}>
                        Order ID</span>
                    </th>
                    <th data-field="Country" className="datatable-cell datatable-cell-sort">
                      <span style={{ width: '137px', }}>
                        Country</span>
                    </th>
                    <th data-field="ShipDate" className="datatable-cell datatable-cell-sort">
                      <span style={{ width: '137px', }}>
                        Ship Date</span>
                    </th>
                    <th data-field="TotalPayment" className="datatable-cell datatable-cell-sort">
                      <span style={{ width: '137px', }}>
                        Payment</span>
                    </th>
                    <th data-field="Status" className="datatable-cell datatable-cell-sort">
                      <span style={{ width: '137px', }}>
                        Status</span>
                    </th>
                    <th data-field="Type" data-autohide-disabled="false" className="datatable-cell datatable-cell-sort">
                      <span style={{ width: '137px', }}>
                        Type</span>
                    </th>
                    <th data-field="Actions" data-autohide-disabled="false" className="datatable-cell datatable-cell-sort">
                      <span style={{ width: '125px', }}>
                        Actions</span>
                    </th> */}
                  </>
                </tr>

                {isMoreThRows === true && createMoreThRows()}
              </thead>

              <Droppable droppableId="tbody">
                {(provided) => (
                  <tbody
                    className="datatable-body data_table_body"
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                  >
                    {createTableRow()}
                    <>
                      {/* <tr data-row="0" className="datatable-row" style={{ left: '0px', }}>
                        <td className="datatable-cell-sorted datatable-cell-center datatable-cell" data-field="RecordID" aria-label="350">
                          <span style={{ width: '30px', }}>
                            350</span>
                        </td>
                        <td data-field="OrderID" aria-label="61957-1072" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            61957-1072</span>
                        </td>
                        <td data-field="Country" aria-label="Czech Republic" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            Czech Republic CZ</span>
                        </td>
                        <td data-field="ShipDate" aria-label="6/29/2017" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            6/29/2017</span>
                        </td>
                        <td data-field="TotalPayment" aria-label="$918964.68" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            $918964.68</span>
                        </td>
                        <td data-field="Status" aria-label="4" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            <span className="label font-weight-bold label-lg  label-light-success label-inline label-bold">
                              Success</span>
                          </span>
                        </td>
                        <td data-field="Type" data-autohide-disabled="false" aria-label="3" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            <span className="label label-success label-dot mr-2">
                            </span>
                            <span className="font-weight-bold text-success">
                              Direct</span>
                          </span>
                        </td>
                        <td data-field="Actions" data-autohide-disabled="false" aria-label="null" className="datatable-cell">
                          <span style={{ overflow: 'visible', position: 'relative', width: '125px', }}>
                            <div className="dropdown dropdown-inline">
                              <a href="#" className="btn btn-sm btn-light btn-text-primary btn-icon mr-2" data-toggle="dropdown" aria-expanded="false">
                                <span className="svg-icon svg-icon-md">
                                  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                      <rect x="0" y="0" width="24" height="24">
                                      </rect>
                                      <path d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" fill="#000000">
                                      </path>
                                    </g>
                                  </svg>
                                </span>
                              </a>
                              <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right" style={{}}>
                                <ul className="navi flex-column navi-hover py-2">
                                  <li className="navi-header font-weight-bolder text-uppercase font-size-xs text-primary pb-2">
                                    Choose an action:                                    </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-print">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        Print</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-copy">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        Copy</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-file-excel-o">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        Excel</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-file-text-o">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        CSV</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-file-pdf-o">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        PDF</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <a href="#" className="btn btn-sm btn-light btn-text-primary btn-icon mr-2" title="Edit details">
                              <span className="svg-icon svg-icon-md">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <rect x="0" y="0" width="24" height="24">
                                    </rect>
                                    <path d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z" fill="#000000" fillRule="nonzero" transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) ">
                                    </path>
                                    <rect fill="#000000" opacity="0.3" x="5" y="20" width="15" height="2" rx="1">
                                    </rect>
                                  </g>
                                </svg>
                              </span>
                            </a>
                            <a href="#" className="btn btn-sm btn-light btn-text-primary btn-icon" title="Delete">
                              <span className="svg-icon svg-icon-md">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <rect x="0" y="0" width="24" height="24">
                                    </rect>
                                    <path d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z" fill="#000000" fillRule="nonzero">
                                    </path>
                                    <path d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3">
                                    </path>
                                  </g>
                                </svg>
                              </span>
                            </a>
                          </span>
                        </td>
                      </tr>

                      <tr data-row="1" className="datatable-row datatable-row-even" style={{ left: '0px', }}>
                        <td className="datatable-cell-sorted datatable-cell-center datatable-cell" data-field="RecordID" aria-label="349">
                          <span style={{ width: '30px', }}>
                            349</span>
                        </td>
                        <td data-field="OrderID" aria-label="61703-423" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            61703-423</span>
                        </td>
                        <td data-field="Country" aria-label="China" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            China CN</span>
                        </td>
                        <td data-field="ShipDate" aria-label="3/5/2016" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            3/5/2016</span>
                        </td>
                        <td data-field="TotalPayment" aria-label="$438995.11" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            $438995.11</span>
                        </td>
                        <td data-field="Status" aria-label="1" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            <span className="label font-weight-bold label-lg label-light-primary label-inline label-bold">
                              Pending</span>
                          </span>
                        </td>
                        <td data-field="Type" data-autohide-disabled="false" aria-label="1" className="datatable-cell">
                          <span style={{ width: '137px', }}>
                            <span className="label label-danger label-dot mr-2">
                            </span>
                            <span className="font-weight-bold text-danger">
                              Online</span>
                          </span>
                        </td>
                        <td data-field="Actions" data-autohide-disabled="false" aria-label="null" className="datatable-cell">
                          <span style={{ overflow: 'visible', position: 'relative', width: '125px', }}>
                            <div className="dropdown dropdown-inline">
                              <a href="#" className="btn btn-sm btn-light btn-text-primary btn-icon mr-2" data-toggle="dropdown">
                                <span className="svg-icon svg-icon-md">
                                  <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                      <rect x="0" y="0" width="24" height="24">
                                      </rect>
                                      <path d="M5,8.6862915 L5,5 L8.6862915,5 L11.5857864,2.10050506 L14.4852814,5 L19,5 L19,9.51471863 L21.4852814,12 L19,14.4852814 L19,19 L14.4852814,19 L11.5857864,21.8994949 L8.6862915,19 L5,19 L5,15.3137085 L1.6862915,12 L5,8.6862915 Z M12,15 C13.6568542,15 15,13.6568542 15,12 C15,10.3431458 13.6568542,9 12,9 C10.3431458,9 9,10.3431458 9,12 C9,13.6568542 10.3431458,15 12,15 Z" fill="#000000">
                                      </path>
                                    </g>
                                  </svg>
                                </span>
                              </a>
                              <div className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                                <ul className="navi flex-column navi-hover py-2">
                                  <li className="navi-header font-weight-bolder text-uppercase font-size-xs text-primary pb-2">
                                    Choose an action:                                    </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-print">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        Print</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-copy">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        Copy</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-file-excel-o">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        Excel</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-file-text-o">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        CSV</span>
                                    </a>
                                  </li>
                                  <li className="navi-item">
                                    <a href="#" className="navi-link">
                                      <span className="navi-icon">
                                        <i className="la la-file-pdf-o">
                                        </i>
                                      </span>
                                      <span className="navi-text">
                                        PDF</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                            <a href="#" className="btn btn-sm btn-light btn-text-primary btn-icon mr-2" title="Edit details">
                              <span className="svg-icon svg-icon-md">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <rect x="0" y="0" width="24" height="24">
                                    </rect>
                                    <path d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z" fill="#000000" fillRule="nonzero" transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) ">
                                    </path>
                                    <rect fill="#000000" opacity="0.3" x="5" y="20" width="15" height="2" rx="1">
                                    </rect>
                                  </g>
                                </svg>
                              </span>
                            </a>
                            <a href="#" className="btn btn-sm btn-light btn-text-primary btn-icon" title="Delete">
                              <span className="svg-icon svg-icon-md">
                                <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                  <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                    <rect x="0" y="0" width="24" height="24">
                                    </rect>
                                    <path d="M6,8 L6,20.5 C6,21.3284271 6.67157288,22 7.5,22 L16.5,22 C17.3284271,22 18,21.3284271 18,20.5 L18,8 L6,8 Z" fill="#000000" fillRule="nonzero">
                                    </path>
                                    <path d="M14,4.5 L14,4 C14,3.44771525 13.5522847,3 13,3 L11,3 C10.4477153,3 10,3.44771525 10,4 L10,4.5 L5.5,4.5 C5.22385763,4.5 5,4.72385763 5,5 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L18.5,6 C18.7761424,6 19,5.77614237 19,5.5 L19,5 C19,4.72385763 18.7761424,4.5 18.5,4.5 L14,4.5 Z" fill="#000000" opacity="0.3">
                                    </path>
                                  </g>
                                </svg>
                              </span>
                            </a>
                          </span>
                        </td>
                      </tr> */}
                    </>
                  </tbody>
                )}
              </Droppable>
            </table>
          </DragDropContext>

          <>
            {/* <div className="datatable-pager datatable-paging-loaded">
              <ul className="datatable-pager-nav my-2 mb-sm-0">
                <li>
                  <a title="First" className="datatable-pager-link datatable-pager-link-first datatable-pager-link-disabled" data-page="1" disabled="disabled">
                    <i className="flaticon2-fast-back">
                    </i>
                  </a>
                </li>
                <li>
                  <a title="Previous" className="datatable-pager-link datatable-pager-link-prev datatable-pager-link-disabled" data-page="1" disabled="disabled">
                    <i className="flaticon2-back">
                    </i>
                  </a>
                </li>
                <li style={{ display: 'none', }}>
                  <input type="text" className="datatable-pager-input form-control" title="Page number" />
                </li>
                <li>
                  <a className="datatable-pager-link datatable-pager-link-number datatable-pager-link-active" data-page="1" title="1">
                    1</a>
                </li>
                <li>
                  <a className="datatable-pager-link datatable-pager-link-number" data-page="2" title="2">
                    2</a>
                </li>
                <li>
                  <a className="datatable-pager-link datatable-pager-link-number" data-page="3" title="3">
                    3</a>
                </li>
                <li>
                  <a className="datatable-pager-link datatable-pager-link-number" data-page="4" title="4">
                    4</a>
                </li>
                <li>
                  <a className="datatable-pager-link datatable-pager-link-number" data-page="5" title="5">
                    5</a>
                </li>
                <li>
                  <a title="Next" className="datatable-pager-link datatable-pager-link-next" data-page="2">
                    <i className="flaticon2-next">
                    </i>
                  </a>
                </li>
                <li>
                  <a title="Last" className="datatable-pager-link datatable-pager-link-last" data-page="18">
                    <i className="flaticon2-fast-next">
                    </i>
                  </a>
                </li>
              </ul>
              <div className="datatable-pager-info my-2 mb-sm-0">
                <div className="dropdown bootstrap-select datatable-pager-size" style={{ width: '60px', }}>
                  <select className="selectpicker datatable-pager-size" title="Select page size" data-width="60px" data-container="body" data-selected="20">
                    <option className="bs-title-option" value="">
                    </option>
                    <option value="5">
                      5</option>
                    <option value="10">
                      10</option>
                    <option value="20">
                      20</option>
                    <option value="30">
                      30</option>
                    <option value="50">
                      50</option>
                    <option value="100">
                      100</option>
                  </select>
                  <button type="button" tabIndex="-1" className="btn dropdown-toggle btn-light" data-toggle="dropdown" role="combobox" aria-owns="bs-select-7" aria-haspopup="listbox" aria-expanded="false" title="Select page size">
                    <div className="filter-option">
                      <div className="filter-option-inner">
                        <div className="filter-option-inner-inner">
                          20</div>
                      </div>
                    </div>
                  </button>
                  <div className="dropdown-menu ">
                    <div className="inner show" role="listbox" id="bs-select-7" tabIndex="-1">
                      <ul className="dropdown-menu inner show" role="presentation">
                      </ul>
                    </div>
                  </div>
                </div>
                <span className="datatable-pager-detail">
                  Showing 1 - 20 of 350</span>
              </div>
            </div> */}
          </>
        </div>
      ) : (
        props.rows.length == 0 ? (
          <div>
            No Data Found
          </div>
        ) : (
          <div className={`row mt-10 ${isPagination === false ? "pb-10" : ""}`}>
            <div className="spinner spinner-dark spinner-lg m-auto"></div>
          </div>
        )

      )}
      {isPagination !== false && createTablePagination()}
    </div>
  );
}
